const Public = ({ children }) => {
  return children
}

export default Public
